// TODO: app 따라 티아라 분리

export const TIARA_PAGE_NAME = {
  ERROR: '에러',
  CONNECTED_SERVICE: '연결된서비스관리',
  WITHDRAWAL: '카카오계정탈퇴',
  MARKETING_USAGE_TERMS: '맞춤형서비스개인정보동의',
  PRESENT_BRIDGE: '제출브릿지',
  PRESENT_CARD_SELECTION: '제출안내',
  PRESENT_TERMS: '제출이용약관동의',
  PRESENT_TERMS_DETAIL: '제출3자제공동의',
  PRESENT_STOP_POPUP: '제출중지',
  PRESENT_COMPLETE: '제출완료',
  PRESENT_FAIL: '제출실패',
  PRESENT_PROGRESS: '제출중',
  INFORMATION_THIRD_PARTY: '개인정보제공받는업체기관',
  EVENT_BENEFIT: '혜택안내홈',
  EVENT_BENEFIT_DETAIL: '혜택안내상세',
  INVALID_EVENT: '유효하지않은이벤트',
  PRESENT_HISTORY: '제출이력',
  PRESENT_CARD_DETAIL: '제출카드상세',
  HOME: '디지털카드홈',
  HOME_SETTING: '디지털카드설정',
  CARD_DELETE: '디지털카드삭제하기'
} as const;

export const TIARA_HOME_PAGE_NAME = {
  ISSUE: '발급안내페이지'
} as const;

export const TIARA_DETAIL_PAGE_NAME = {
  CARD_DETAIL: '카드상세',
  CARD_DETAIL_GROUP_ACTION: '카드상세_그룹액션',
  CARD_INFO: '카드정보',
  CARD_LIST: '카드목록'
} as const;

export const TIARA_ISSUE_PAGE_NAME = {
  ISSUE: '발급하기',
  ISSUE_COMPLETE: '발급완료',
  ISSUE_FAIL: '발급실패'
} as const;

export type TiaraPageName = (typeof TIARA_PAGE_NAME)[keyof typeof TIARA_PAGE_NAME];

export const TIARA_ACTION = {
  ISSUE_CLICK: '발급하기_클릭', // 공통
  CLOSE_CLICK: '닫기_클릭', // 공통
  BACK_CLICK: '이전_클릭', // 공통
  INVALID_VERSION_ERROR: '에러_최신버전업데이트_보기',
  INVALID_VERSION_CLICK: '최신버전업데이트하기_클릭',
  EXTERNAL_BROWSER_ERROR: '에러_외부웹브라우저_보기',
  EXTERNAL_BROWSER_OPEN_KAKAOTALK_CLICK: '외부웹브라우저카카오톡으로열기_클릭',
  EXTERNAL_BROWSER_INSTALL_KAKAOTALK_CLICK: '외부웹브라우저카카오톡설치하기_클릭',
  NOTFOUND_ERROR: '에러_페이지알수없음_보기',
  SERVICE_ERROR: '에러_서비스오류_보기',
  INVALID_LOGIN_ERROR: '에러_계정미로그인_보기',
  INVALID_LOGIN_CONFIRM_CLICK: '계정미로그인확인_클릭',
  UNDER_MAINTENANCE_ERROR: '에러_서비스점검_보기',
  NETWORK_ERROR: '에러_네트워크에러_보기',
  NETWORK_ERROR_REFRESH_CLICK: '네트워크에러새로고침_클릭',
  INVALID_DEVICE_ERROR: '에러_서브디바이스미지원_보기',
  INVALID_CARD_INFO_ERROR: '에러_카드정보유효안함_보기',
  VIEW_TERMS_SERVICE: '연결된서비스관리카드리스트_보기',
  VIEW_TERMS_WITHDRAWAL_CARDS: '카카오계정탈퇴카드리스트_보기',
  MARKETING_USAGE_TERMS_VIEW: '맞춤형서비스개인정보동의_보기',
  PRESENT_BRIDGE_VIEW: '제출브릿지_보기',
  PRESENT_CARD_SELECTION_VIEW: '제출안내_보기',
  NEXT_CLICK: '다음_클릭',
  PRESENTABLE_CARD_CLICK: '제출가능한카드_클릭',
  PRESENT_TERMS_VIEW: '제출이용약관동의_보기',
  ALL_AGREEMENT_CLICK: '전체동의_클릭',
  ALL_AGREEMENT_CANCEL_CLICK: '전체동의해제_클릭',
  REQUIRED_TERMS_CLICK: '필수항목개별_클릭',
  REQUIRED_TERMS_CANCEL_CLICK: '필수항목개별해제_클릭',
  OPTIONAL_TERMS_CLICK: '선택항목개별_클릭',
  OPTIONAL_TERMS_CANCEL_CLICK: '선택항목개별해제_클릭',
  DETAIL_VIEW_CLICK: '보기_클릭',
  AGREE_AND_PRESENT_CLICK: '동의후제출하기_클릭',
  AGREE_AND_SIGN_CLICK: '인증후제출하기_클릭',
  PRESENT_THIRD_TERMS_VIEW: '제출3자제공동의_보기',
  CONFIRM_CLICK: '확인_클릭',
  PRESENT_STOP_POPUP_VIEW: '제출중지_보기',
  CANCEL_CLICK: '취소_클릭',
  PRESENT_COMPLETE_VIEW: '제출완료_보기',
  PRESENT_FAIL_INVALID_CARD_STATE_VIEW: '제출실패_카드정보유효안함_보기',
  PRESENT_FAIL_PARTNER_SYSTEM_ERROR_VIEW: '제출실패_제출처시스템오류_보기',
  PRESENT_FAIL_USER_STOP_VIEW: '제출실패_제출중단_보기',
  PRESENT_FAIL_TIMEOUT_VIEW: '제출실패_제출요청유효시간만료_보기',
  PRESENT_FAIL_UNDEFINED_ERROR_VIEW: '제출실패_미정의오류_보기',
  PRESENT_FAIL_INVALID_ACCOUNT_VIEW: '제출실패_대상자아님_보기',
  PRESENTATION_INVALID_AUTH: '제출실패_대상자아님_본인인증불일치_보기',
  SIGN_NOT_PROGRESS: '제출실패_인증서명미완료오류_보기',
  INVALID_PRESENTATION_STATE: '제출실패_유효하지않은요청_보기',
  EXPIRED: '제출실패_만료된요청_보기',
  PRESENT_FAIL_CARD_NOT_FOUND: '제출실패_조건불일치_보기',
  OWN_CARDS_VIEW_CLICK: '보유한카드보기_클릭',
  INFORMATION_THIRD_PARTY_VIEW: '개인정보제공받는업체기관_보기',
  PRESENT_PROGRESS_VIEW: '제출중_보기',
  PRESENT_PROGRESSING_VIEW: '제출진행중_보기',
  EVENT_BENEFIT_VIEW: '혜택안내홈_보기',
  BEST_SECTION_CLICK: '베스트섹션_클릭',
  AUTOPLAY_STOP_CLICK: '베스트섹션_일시정지_클릭',
  AUTOPLAY_PLAY_CLICK: '베스트섹션_재생_클릭',
  SPECIAL_SECTION_CLICK: '스페셜섹션_클릭',
  GROUP_SECTION_CLICK: '그룹섹션_클릭',
  SHARE_CLICK: '공유_클릭',
  TERMS_CLICK: '이용약관_클릭',
  PARTNER_CLICK: '제휴안내_클릭',
  KAKAO_CLICK: '(주)카카오_클릭',
  EVENT_BENEFIT_DETAIL_VIEW: '혜택안내상세_보기',
  BUTTON_CLICK: '버튼_클릭',
  LOGIN_REQUIRED_POPUP: '계정로그인_보기',
  NO_DIGITAL_CARD_POPUP: '디지털카드미보유_보기',
  SEND_ISSUE_REQUEST_POPUP: '발급요청알림톡_보기',
  SEND_ISSUE_REQUEST_FAIL_POPUP: '발급요청알림톡실패_보기',
  EXPIRED_EVENT_POPUP: '진행중아님_보기',
  RESEND_CLICK: '다시보내기_클릭',
  EVENT_BENEFIT_HEADER_CLICK: '디지털카드혜택_클릭',
  INVALID_EVENT: '유효하지않은이벤트_보기',
  EVENT_CLICK: '다른디지털카드혜택_클릭',
  PRESENT_HISTORY_VIEW: '제출이력_보기',
  PRESENT_CARD_SELECT_CLICK: '카드선택_클릭',
  PRESENT_CARD_UNSELECT_CLICK: '카드선택해제_클릭',
  PRESENT_CARD_PREVIEW_CLICK: '카드보기_클릭',
  PRESENT_CARD_DETAIL_VIEW: '제출카드상세_보기',
  ONLY_MOBILE: '모바일확인_보기',
  SUCCESS_BENEFIT: '지급성공_보기',
  FAILURE_BENEFIT: '지급실패_보기',
  ERROR_BENEFIT: '지급오류_보기',
  HOME_VIEW: '디지털카드홈_보기',
  SETTING_CLICK: '설정_클릭',
  NOTICE_CLICK: '공지_클릭',
  BANNER_CLICK: '상단배너_클릭',
  MY_CARD_CLICK: '내카드_클릭',
  CARD_MORE_VIEW_CLICK: '카드더보기_클릭',
  EDIT_CLICK: '편집_클릭',
  RECOMMEND_CARD_CLICK: '발급추천카드_클릭',
  RECOMMEND_MORE_CLICK: '추천더보기_클릭',
  BEST_BENEFIT_CLICK: '혜택베스트_클릭',
  BENEFIT_LIST_CLICK: '혜택리스트_클릭',
  BENEFIT_VIEW_CLICK: '혜택바로가기_클릭',
  PRIVACY_POLICY_CLICK: '개인정보처리방침_클릭',
  MANAGEMENT_POLICY_CLICK: '운영정책_클릭',
  BUSINESS_INFO_CLICK: '사업자정보_클릭',
  BUSINESS_INFO_CONFIRM_CLICK: '사업자정보확인_클릭',
  HOME_SETTING_VIEW: '디지털카드설정_보기',
  PRESENT_HISTORY_CLICK: '제출이력_클릭',
  DIGITALCARD_CHANNEL_CLICK: '톡디지털카드채널_클릭',
  CS_CLICK: '고객센터_클릭',
  PROPOSITION_CLICK: '제휴제안_클릭',
  CARD_DELETE_VIEW: '디지털카드삭제하기_보기',
  CARD_DELETE_CLICK: '디지털카드삭제_클릭',
  FOREIGNER: '해외사용자_보기',
  EVENT_POPUP_VIEW: '이벤트팝업_보기',
  EVENT_POPUP_CLICK: '이벤트팝업_클릭',
  EVENT_POPUP_DO_NOT_SHOW_AGAIN_CLICK: '이벤트팝업_다시보지않기_클릭',
  EVENT_POPUP_CLOSE_VIEW: '이벤트팝업_닫기_클릭'
} as const;

export const TIARA_ISSUE_ACTION = {
  FAIL_ISSUE_VIEW: '발급실패_보기',
  SUCCESS_ISSUE_VIEW: '발급완료_보기',
  FAIL_UNAUTHENTICATED_USER_VIEW: '발급실패_본인인증안함_보기',
  FAIL_INVALID_USER_AUTHENTICATION_VIEW: '발급실패_본인인증유효안함_보기',
  FAIL_INVALID_CREDENTIAL_CONTENT_VIEW: '발급실패_카드정보유효안함_보기',
  FAIL_PARTNER_SYSTEM_ERROR_VIEW: '발급실패_발급처시스템오류_보기',
  FAIL_PARTNER_CHANNEL_ERROR_VIEW: '발급실패_앱채널연결해제오류_보기',
  FAIL_SIGN_STOPPED_VIEW: '발급실패_인증서명중단실패오류_보기',
  FAIL_ISSUE_UNDEFINED_VIEW: '발급실패_미정의오류_보기',
  ISSUE_VIEW: '발급하기_보기',
  ALREADY_ISSUED_ERROR_VIEW: '에러_이미보유중_보기',
  INVALID_ACCOUNT_ERROR_VIEW: '에러_발급대상자아님_보기',
  CANCELED_REQUEST_ERROR_VIEW: '에러_카드발급취소_보기',

  VIEW_DIGITAL_CARD_CLICK: '디지털카드보기_클릭'
} as const;

export const TIARA_HOME_ACTION = {
  TOO_MANY_REQUEST: '발급지연팝업_보기',
  PAPAS_MAINTENANCE: '발급안내점검중팝업_보기',
  ISSUE_VIEW: '발급안내_보기',
  SHARE_CLICK: '공유하기_클릭',
  ISSUE_CLICK: '발급받기_클릭',
  TOO_MANY_REQUEST_CONFIRM_CLICK: '발급지연팝업확인_클릭'
} as const;

export const TIARA_DETAIL_ACTION = {
  // 카드상세
  CARD_VIEW: '디지털카드_보기',
  CLOSE_CLICK: '닫기_클릭',
  GROUP_ACTION_MENU_CLICK: '그룹액션메뉴_클릭',
  RIGHT_SWIPE: '오른쪽_스와이프',
  LEFT_SWIPE: '왼쪽_스와이프',
  CARD_CLICK: '카드_클릭',
  FOLD_CLICK: '접기_클릭',
  CARD_LIST_CLICK: '카드목록_클릭',
  // 카드상세_그룹액션
  GROUP_ACTION_MENU_VIEW: '그룹액션메뉴_보기',
  GROUP_ACTION_BUTTON_CLICK: '그룹액션버튼_클릭',
  CARD_DELETE_CLICK: '카드삭제_클릭',
  // 카드정보
  CARD_INFO_VIEW: '카드정보_보기',
  CARD_INFO_LINK_CLICK: '상제정보링크_클릭',
  CARD_DISCRIPTION_LINK_CLICK: '부연설명링크_클릭',
  // 카드목록
  CARD_LIST_VIEW: '카드목록_보기',
  CARD_LIST_CARD_CLICK: '카드_클릭',
  // 카드없음
  CARD_NOT_FOUND_VIEW: '보유카드없음_보기'
} as const;

export type TiaraAction = (typeof TIARA_ACTION)[keyof typeof TIARA_ACTION];
